module.exports = __webpack_public_path__ + "./img/summary_arrow.svg";